import {
  AppMinimumRequirementsForPasswordForm,
  AppMinimumRequirementsForRecaptcha,
  EmailAddress_WithIsEmailRegisteredAlready_DebouncedField,
  emailAddress_withIsEmailRegisteredAlready_formLogic,
  InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland,
  mobileFormLogic,
  nameFormLogic,
  passwordConfirmFormLogic,
  passwordFormLogic,
  recaptchaFormLogic,
} from "../../form/logic";

import { GenericForm, GenericFormLogic } from "../../hooks";

export interface JoinForm extends GenericForm {
  emailAddress?: string;
  emailAddressError?: string;
  emailAddressDebouncedValidation?: EmailAddress_WithIsEmailRegisteredAlready_DebouncedField;

  firstName?: string;

  lastName?: string;

  mobile?: string;

  password?: string;

  confirmPassword?: string;

  subscribe?: boolean;
}

export interface InitialStateMinimumRequirements_JoinForm {
  join_form_recaptcha: InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland;
}

export type JoinFormApp = AppMinimumRequirementsForPasswordForm &
  AppMinimumRequirementsForRecaptcha & {
    initialState: InitialStateMinimumRequirements_JoinForm;
  };

export const JoinFormLogic: GenericFormLogic<JoinForm, JoinFormApp> = {
  emailAddress: emailAddress_withIsEmailRegisteredAlready_formLogic({
    required: true,
  }),
  firstName: nameFormLogic({
    required: true,
  }),
  lastName: nameFormLogic({
    required: true,
  }),
  mobile: mobileFormLogic({
    required: false,
  }),
  password: passwordFormLogic({
    required: true,
  }),
  confirmPassword: passwordConfirmFormLogic({
    required: true,
    passwordFormKey: "password",
  }),
  recaptcha: recaptchaFormLogic<JoinForm, JoinFormApp>({
    initialStateKey: "join_form_recaptcha",
  }),
} as const;

export const initialJoinForm = (): JoinForm => ({
  subscribe: true,
});
